// @flow
import React from 'react';

import {gt} from 'app/utils/i18n';

import {BaseTour, TourStep} from './BaseTour';

const steps: Array<TourStep> = [
  {
    role: 'any',
    title: gt('Editing a Procedure'),
    content: gt('Here is a quick tour to show you how to edit a Procedure.'),
    target: 'body',
    placement: 'center',
  },
  {
    role: 'any',
    title: gt('Edit the Procedure Title'),
    content: gt(
      'First, click this top area to edit the procedure title, overview, and tags.  Every change you make will be saved automatically.'
    ),
    target: '#document-head .container',
  },
  {
    role: 'any',
    title: gt('Edit The First Step'),
    content: gt(
      'Click any step to edit it.  You can add a title, description, images, and videos to each step.'
    ),
    target: '.steps-list-tour li:nth-of-type(1)',
  },
  {
    role: 'any',
    title: gt('Add Another Step'),
    content: gt(
      'There is an Add Step button at the bottom of this page. You can add as many steps as you want.'
    ),
    target: '.add-step-tour',
  },
  {
    role: 'any',
    title: gt('View your Work'),
    content: gt(
      'Click this button to see the %(draft)s procedure with your changes.',
      {draft: <i>draft</i>}
    ),
    target: '.view-draft-tour',
    spotlightPadding: 2,
  },
  {
    role: 'manager',
    title: gt('Publish your work'),
    content: gt(
      'If you have any draft changes, an %(approve)s button will appear here so you can approve them.',
      {approve: <i>Approve</i>}
    ),
    target: '.request-or-approve-tour',
    spotlightPadding: 2,
  },
  {
    role: 'teammate',
    title: gt('Get your changes published'),
    content: gt(
      'A manager must approve your changes before they are live. Request approval here.'
    ),
    target: '.request-or-approve-tour',
    spotlightPadding: 2,
  },
  {
    role: 'manager',
    title: gt('Move to Recycle Bin'),
    content: gt(
      'If you don\'t want to keep this procedure, you can move it to Recycle Bin by clicking here and selecting "Move to Recycle Bin".'
    ),
    target: '.procedure-actions-tour',
    spotlightPadding: 2,
  },
  {
    role: 'any',
    title: gt('Go Back to the Dashboard'),
    content: gt(
      'Finished working on this procedure?  Click here to go back to the dashboard where you can manage all of your procedures.'
    ),
    target: '.breadcrumb .breadcrumb-item:first-child',
  },
  {
    role: 'manager',
    title: gt("That's all for now..."),
    content: (
      <div>
        {gt('This concludes your tour of editing a Procedure.')}
        <h3 className="my-2" style={{fontSize: 18}}>
          {gt('Where to from here?')}
        </h3>
        {gt(
          'You can make some edits, share this procedure with a teammate (or the world), or go back to your dashboard.'
        )}
      </div>
    ),
    target: 'body',
    placement: 'center',
  },
  {
    role: 'teammate',
    title: gt("That's all for now..."),
    content: (
      <div>
        {gt('This concludes your tour of editing a Procedure.')}
        <h3 className="my-2" style={{fontSize: 18}}>
          {gt('Where to from here?')}
        </h3>
        {gt(
          'You can make some edits, request approval for some changes, or go back to your dashboard.'
        )}
      </div>
    ),
    target: 'body',
    placement: 'center',
  },
];

export const ProcedureEditTour = (): JSX.Element => (
  <BaseTour tourname="edit" steps={steps} />
);
